export const PARAMETERS = 'parameters';

// PPFE-0002
export const PPFE_0002_TREATMENT_KEY = 'ppfe-0002';

// TRI-0138
export const TRI0138_TREATMENT_KEY = 'tri-0138';

// TRI-0140
export const TRI0140_TREATMENT_KEY = 'tri-0140';
export const PPFE_0002_GROUP_PARAMETER_KEY = 'group';
export let PPFE_0002_GROUP_PARAMETER_OPTIONS;

// PPIA-0001
(function (PPFE_0002_GROUP_PARAMETER_OPTIONS) {
  PPFE_0002_GROUP_PARAMETER_OPTIONS["control"] = "control";
  PPFE_0002_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(PPFE_0002_GROUP_PARAMETER_OPTIONS || (PPFE_0002_GROUP_PARAMETER_OPTIONS = {}));
export const PPIA_0001_TREATMENT_KEY = 'ppia-0001';
export const PPIA_0001_GROUP_PARAMETER_KEY = 'group';
export let PPIA_0001_GROUP_PARAMETER_OPTIONS;

// PPIA-0002
(function (PPIA_0001_GROUP_PARAMETER_OPTIONS) {
  PPIA_0001_GROUP_PARAMETER_OPTIONS["control"] = "control";
  PPIA_0001_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(PPIA_0001_GROUP_PARAMETER_OPTIONS || (PPIA_0001_GROUP_PARAMETER_OPTIONS = {}));
export const PPIA_0002_TREATMENT_KEY = 'ppia-0002';
export const PPIA_0002_GROUP_PARAMETER_KEY = 'group';
export let PPIA_0002_GROUP_PARAMETER_OPTIONS;

// PPFE-0003
(function (PPIA_0002_GROUP_PARAMETER_OPTIONS) {
  PPIA_0002_GROUP_PARAMETER_OPTIONS["control"] = "control";
  PPIA_0002_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(PPIA_0002_GROUP_PARAMETER_OPTIONS || (PPIA_0002_GROUP_PARAMETER_OPTIONS = {}));
export const PPFE_0003_TREATMENT_KEY = 'ppfe-0003';
export const PPFE_0003_GROUP_PARAMETER_KEY = 'group';
export let PPFE_0003_GROUP_PARAMETER_OPTIONS;

// UBX-0001
(function (PPFE_0003_GROUP_PARAMETER_OPTIONS) {
  PPFE_0003_GROUP_PARAMETER_OPTIONS["control"] = "control";
  PPFE_0003_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(PPFE_0003_GROUP_PARAMETER_OPTIONS || (PPFE_0003_GROUP_PARAMETER_OPTIONS = {}));
export const UBX_0001_TREATMENT_KEY = 'ubx-0001';
export const UBX_0001_GROUP_PARAMETER_KEY = 'group';
export let UBX_0001_GROUP_PARAMETER_OPTIONS;
(function (UBX_0001_GROUP_PARAMETER_OPTIONS) {
  UBX_0001_GROUP_PARAMETER_OPTIONS["control"] = "control";
  UBX_0001_GROUP_PARAMETER_OPTIONS["variation"] = "variation";
})(UBX_0001_GROUP_PARAMETER_OPTIONS || (UBX_0001_GROUP_PARAMETER_OPTIONS = {}));